<template>
  <v-data-table
      loading-text="Loading... Please wait"
      class="users-table"
      :headers="headersProjectsClient"
      :options.sync="paginationProjectsClient"
      :server-items-length="totalProjectsClient"
      :items-per-page-options="rowsPerPageProjectsClient"
      :footer-props="footerOptionsProjectsClient"
      :items="projectsClient"
      :page.sync="currentPageProjectsClient"
      mobile-breakpoint="0"
  >
    <template v-slot:item.actions="{ item }">
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              v-bind="attrs"
              v-on="on"
              icon
              @click="showProject(item.id)">
            <v-icon color="fontDefault">preview</v-icon>
          </v-btn>
        </template>
        <span>{{ languageData.preview }}</span>
      </v-tooltip>
    </template>
  </v-data-table>
</template>

<script type="text/javascript">
  import { mapActions, mapState } from "vuex";
  import router from "../../../../../../router";

  export default {
    name: "ProjectsRelation",
    data() {
      return {
        footerOptionsProjectsClient: {
          'items-per-page-options': [20, 50, 100],
          'disablePagination': false
        },
        currentPageProjectsClient: 1,
      }
    },
    methods: {
      ...mapActions("getHeadersProjectsClient", ["getHeadersProjectsClient"]),
      ...mapActions("getProjectsClient", ["getProjectsClient"]),
      searchProjectsClient: function(valueSearch={}, filters=false) {
        valueSearch.language = this.getCurrentLanguage;
        valueSearch.filters = filters;
        this.getProjectsClient({ valueSearch });
        if(filters) {
          this.currentPageProjectsClient = 1;
        }
      },
      showProject: function(id) {
        let r = router.resolve({ path: "/projects/edit", query: { id: id } })
        window.location.assign(r.href)
      }
    },
    computed: {
      ...mapState("getHeadersProjectsClient", {
        headersProjectsClient: state => state.headersProjectsClient
      }),
      paginationProjectsClient: {
        set: function(value) {
          this.searchProjectsClient(value);
        },
        get: function() {
          return this.$store.state.getProjectsClient.paginationProjectsClient;
        }
      },
      ...mapState("getProjectsClient", {
        totalProjectsClient: state => state.paginationProjectsClient.totalItems,
        rowsPerPageProjectsClient: state => state.paginationProjectsClient.rowsPerPage,
        projectsClient: state => state.dataReceive
      }),
    },
    mounted() {
      const language = this.getCurrentLanguage;
      this.getHeadersProjectsClient({ creds: { language } });
    }
  }
</script>